import React from "react";
import "./styles.css";

const steps = [
  {
    step: "1",
    title: "Initial Consultation",
    description:
      "Free consultation to understand your medical needs and recommend suitable treatment options.",
  },
  {
    step: "2",
    title: "Medical Evaluation",
    description:
      "Comprehensive review of medical records and virtual consultation with specialists.",
  },
  {
    step: "3",
    title: "Treatment Planning",
    description:
      "Customized treatment plan with detailed cost breakdown and timeline. \n",
  },
  {
    step: "4",
    title: "Travel Arrangements",
    description:
      "Complete travel coordination including visa, flights, and accommodation booking.",
  },
  {
    step: "5",
    title: "Medical Treatment",
    description:
      "Receive world-class treatment with dedicated care coordination and support.",
  },
  {
    step: "6",
    title: "Recovery & Follow-up",
    description:
      "Post-treatment care, recovery support, and ongoing medical follow-up.",
  },
];

const MedicalJourneyProcess = () => {
  return (
    <section className="rr-features-area pt-90 pb-70 fix">
      <div className="container">
        {/* Section Title */}
        <div className="row">
          <div
            className="col-xl-12 text-left mb-45"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <h3 className="rr-section-title ">Your Medical Journey Process</h3>
          </div>
        </div>
        {/* Cards */}
        <div className="row">
          {steps.map((item, index) => (
            <div
              key={index}
              className="col-xl-4 col-lg-4 col-md-6 col-12 py-4"
              data-wow-duration=".9s"
              data-wow-delay={`${0.3 + index * 0.2}s`}
            >
              <div className="medical-card card p-relative wow rrfadeUp">
                {/* Top Background with Number */}
                <div
                  className="medical-thumb"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <img
                    src="assets/imgs/banner/bg-img.png"
                    alt="bg"
                    className="thumb-img"
                  />
                  <span className="medical-step">{item.step}</span>
                </div>
                {/* Icon */}
                <div className="medical-icon">
                  <img
                    src={`assets/imgs/service/service__item-${index + 1}.png`}
                    alt="icon"
                  />
                </div>
                {/* Content */}
                <div className="medical-content text-center">
                  <h5 className="medical-title">
                    <a href={item.link || "#"}>{item.title}</a>
                  </h5>
                  <p>{item.description}</p>
                  <a className="medical-btn" href={item.link || "#"}></a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MedicalJourneyProcess;

// const MedicalJourneyProcess = () => {
//   return (
//     <div
//       className="py-5"
//       style={{
//         background: "linear-gradient(to right, #080ce7, #185ec8)",
//         color: "white",
//         borderRadius:"18px"
//       }}
//     >
//       <div className="container text-center">
//         <h3 className="fw-bold mb-4 text-white">Your Medical Journey Process</h3>
//         <div className="row g-4">
//           {steps.map((item, index) => (
//             <div key={index} className="col-12 col-sm-6 col-lg-4">
//               <div className="bg-white text-dark rounded-4 shadow p-4 h-100">
//                 <div
//                   className="rounded-circle d-inline-block mb-3 fw-bold text-white"
//                   style={{
//                     backgroundColor: "#185ec8",
//                     width: "35px",
//                     height: "35px",
//                     lineHeight: "35px",
//                   }}
//                 >
//                   {item.step}
//                 </div>
//                 <h5 className="fw-bold">{item.title}</h5>
//                 <p className="small text-muted mb-0">{item.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MedicalJourneyProcess;
